<template>
  <main class="main">
    <div id="recaptcha-container"></div>
    <v-container id="container">
      <div class="login" id="login-signup">
        <div class="login-banner">
          <img src="@/assets/images/login-snap.svg" alt="" />
          <div class="login-content">
            <v-row>
              <v-col data-aos="fade-up">
                <div
                  v-text="'Welcome to RouteLine!'"
                  class="text-h5 text-light font-weight-bold"
                ></div>
                <div
                  v-text="'Please register using your phone number.'"
                  class="text-subtitle-1 text-light"
                ></div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="login-form" id="signup-page">
          <div class="form" data-aos="fade-up" id="signup-fadeUp">
            <div
              id="head-text"
              v-text="!hasSendOtp ? 'Create Account' : 'Enter OTP'"
              class="text-h4 text-secondary font-weight-bold mb-3"
            ></div>
            <form @submit.prevent="handleLogin" v-if="!hasSendOtp">
              <v-row>
                <v-col>
                  <v-text-field
                    id="First-Name"
                    v-model="user.fName"
                    label="First Name"
                    column="6"
                    outlined
                    required
                    rounded
                  />
                </v-col>
                <v-col>
                  <v-text-field
                  id="Last-name"
                    v-model="user.lName"
                    label="Last Name"
                    outlined
                    column="6"
                    rounded
                    required
                  />
                </v-col>
              </v-row>
              <v-text-field
                id="phone"
                v-model="user.phone"
                label="Phone"
                outlined
                required
                rounded
                :disabled="$route.query.phone ? true : false"
                type="tel"
              />
              <v-text-field
                id="email"
                v-model="user.email"
                label="Email"
                type="email"
                outlined
                required
                rounded
              />
              <!--  date of birth picker -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <!-- year  -->
                  <v-select
                    id="DOB-Year"
                    v-model="userDOB.year"
                    :items="years"
                    label="Date of Birth Year"
                    outlined
                    required
                    rounded
                  ></v-select>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <!-- month  -->
                  <v-select
                    id="DOB-Month"
                    v-model="userDOB.month"
                    :items="months"
                    label="Month"
                    outlined
                    required
                    rounded
                  ></v-select>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <!-- day  -->
                  <v-select
                    id="DOB-Day"
                    v-model="userDOB.day"
                    :items="days"
                    label="Day"
                    outlined
                    required
                    rounded
                  ></v-select>
                </v-col>
              </v-row>

              <v-checkbox v-model="user.agree" id="checkbox-agree">
                <template v-slot:label>
                  <div>
                    I agree to the
                      <template>
                        <a
                          @click="dialog = true"
                          href="#" id="agree-a"
                        >
                          Terms and Conditions 
                        </a>
                      </template>
                  </div>
                </template>
              </v-checkbox>

              <v-btn
                color="primary"
                block
                large
                rounded
                type="submit"
                :loading="loading"
                id="register"
              >
                Register
              </v-btn>
            </form>
            <form @submit.prevent="handleLogin" v-else>
              <v-otp-input
                outlined
                rounded
                label="Verification code"
                v-model="otp"
                @finish="verifyOtp"
                type="password"
                id="password-input"
              >
              </v-otp-input>

              <v-btn
                color="primary"
                block
                large
                rounded
                type="submit"
                :loading="loading"
                id="verify-btn"
              >
                VERIFY OTP
              </v-btn>
            </form>
          </div>
        </div>
      </div>
    </v-container>

    <v-dialog
      v-model="dialog"
      max-width="700px"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Terms and Conditions
        </v-card-title>

        <v-card-text class="pt-4 pb-4">

          <Terms />

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          id="agree"
            color="primary"
            text
            @click="() => {
              user.agree = true;
              dialog = false;
            }"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </main>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/compat/app";
import moment from "moment";
import axios from "../../modules/axios";
import Terms from "@/views/terms.vue";
// import Button from '../../components/buttons/Button.vue';

export default {
  components: { Terms },
  data() {
    return {
      user: {
        fName: "",
        lName: "",
        dob: "",
        phone: "",
        email: "",
        agree: false,
      },
      userDOB: {
        day: "",
        month: "",
        year: "",
      },
      loading: false,
      hasSendOtp: false,
      captchaVerifier: null,
      country: "+1",
      otp: "",
      dialog: false,
    };
  },
  mounted() {
    if (this.$route.query.phone) {
      this.user.phone = this.$route.query.phone || "";
    }
  },
  created() {
    this.initReCaptcha();
  },
  methods: {
    async handleLogin() {
      if (this.user.phone.length !== 10) {
        const msg = this.$t("invalidPhoneNumber");
        this.$toasted.show(msg);
        return;
      }
      this.loading = true;
      // data for create user
      let userData = {
        phoneNumber: this.country + this.user.phone,
        email: this.user.email,
        first_name: this.user.fName,
        last_name: this.user.lName,
        dob: moment(
          `${this.userDOB.year}-${this.userDOB.month}-${this.userDOB.day}`,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD"),
      };
      // user axios create user
      await axios
        .post("/users", userData)
        .then((res) => {
          console.log(res.data);
          this.$toasted.show("User Register Successfully");
          this.$router.push("/login");
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          this.$toasted.show("Somthing went wrong, please try again, Later");
        })
        .finally(() => {
          this.loading = false;
          // redirect to login
        });
    },
    async verifyOtp() {
      this.loading = true;
      try {
        const user = await window.confirmationResult.confirm(this.otp);
        if (user) {
          await this.$fire.firestore
            .collection("users")
            .doc(user?.user.uid)
            .set({
              name: this.user.name,
              phone: this.user.phone,
              email: this.user.email,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
              role: "customer", ///
              membership: false,
              subscriptionID: "",
              uid: user?.user.uid,
            });

          this.$toasted.show("Welcome to Routline!");
          this.$router.push("/");
        }
      } catch (e) {
        this.$toasted.show("OTP NOT MATCH");
      } finally {
        this.loading = false;
      }
    },
    initReCaptcha() {
      if (!process.browser) {
        return;
      }
      setTimeout(() => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
            callback() {},
            "expired-callback"() {},
          }
        );
        this.captchaVerifier = window.recaptchaVerifier;
      }, 1000);
    },
    checkLogin() {
      if (this.currentUser) {
        this.$router.push("/");
      }
    },
    async checkUserAvailable(phoneNumber) {
      try {
        const snap = await this.$fire.firestore
          .collection("users")
          .where("phone", "==", phoneNumber)
          .get();
        if (snap.size) {
          return true;
        }

        return false;
      } catch (error) {
        return false;
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "getUser",
    }),
    months() {
      return [
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ];
    },
    days() {
      return [
        { text: "1", value: "01" },
        { text: "2", value: "02" },
        { text: "3", value: "03" },
        { text: "4", value: "04" },
        { text: "5", value: "05" },
        { text: "6", value: "06" },
        { text: "7", value: "07" },
        { text: "8", value: "08" },
        { text: "9", value: "09" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
        { text: "17", value: "17" },
        { text: "18", value: "18" },
        { text: "19", value: "19" },
        { text: "20", value: "20" },
        { text: "21", value: "21" },
        { text: "22", value: "22" },
        { text: "23", value: "23" },
        { text: "24", value: "24" },
        { text: "25", value: "25" },
        { text: "26", value: "26" },
        { text: "27", value: "27" },
        { text: "28", value: "28" },
        { text: "29", value: "29" },
        { text: "30", value: "30" },
        { text: "31", value: "31" },
      ];
    },
    years() {
      // after 18 year to 100 year using moment js
      const years = [];
      const currentYear = moment().year();
      for (let i = currentYear - 25; i >= currentYear - 100; i--) {
        years.push({ text: i, value: i });
      }
      return years;
    },
    generateDob() {
      let dob = `${this.userDOB.day}-${this.userDOB.month}-${this.userDOB.year}`;
      // this.user.dob = dob;
      return dob;
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  max-width: 300px;
}
.login {
  display: flex;

  &-banner {
    position: relative;
  }

  &-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 20px;
    background: var(--light);
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.main {
  position: relative;
  height: 100vh;
  width: 100%;
  background: rgba(111, 115, 3, 0.15);
  opacity: 1;
  display: flex;
  align-items: center;
}
.logo {
  // width: 100%;
  height: 50px;
}
.card-login {
  padding: 30px;
}

@media screen and (max-width: 1200px) {
  .login {
    max-width: 100%;

    &-banner {
      display: none;
    }
    &-form {
      // height: 70vh;
    }
  }
}
</style>
